import { render } from "./ImageMagnifier.vue?vue&type=template&id=490c5bcd"
import script from "./ImageMagnifier.vue?vue&type=script&lang=js"
export * from "./ImageMagnifier.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__